import React, { useEffect, useMemo } from "react";
import { Box, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useLocation } from "react-router-dom";

const RibbonNavbar = ({
  selectedRows = [],
  onAdd,
  onEdit,
  onView,
  onDelete,
  onApprove,
}) => {
  const user = JSON.parse(localStorage.getItem("loggedUser")) || {};
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  /* 🔐 Resolve module permissions */
  const moduleFunctions = useMemo(() => {
    const currentModuleFunction = user.userRoles
      ?.flatMap((role) => role.functions || [])
      .find(
        (f) => f.uriPath?.toLowerCase() === location.pathname.toLowerCase()
      );

    const moduleName = currentModuleFunction?.modules?.name;

    return (
      user.userRoles
        ?.flatMap((role) => role.functions || [])
        .filter((f) => f.modules?.name === moduleName) || []
    );
  }, [user, location.pathname]);

  const canAdd = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "CREATE")
  );
  const canEdit = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "UPDATE")
  );
  const canView = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "READ")
  );
  const canDelete = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "DELETE")
  );
  const canApprove = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "APPROVE")
  );

  useEffect(() => {
    console.log("Selected Rows:", selectedRows);
  }, [selectedRows]);

  const iconStyle = {
    color: "#042d8c",
    borderRadius: "12px",
    padding: isMobile ? "6px" : "8px",
    "&:hover": { transform: "scale(1.15)" },
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: isMobile ? 1.5 : 3,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {canAdd && (
        <Tooltip title="Add" arrow>
          <IconButton onClick={onAdd} sx={iconStyle}>
            <AddCircleOutlineIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </Tooltip>
      )}

      {canEdit && (
        <Tooltip title="Edit" arrow>
          <IconButton
            onClick={onEdit}
            disabled={selectedRows.length !== 1}
            sx={iconStyle}
          >
            <EditNoteIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </Tooltip>
      )}

      {canView && (
        <Tooltip title="View" arrow>
          <IconButton
            onClick={onView}
            disabled={selectedRows.length === 0}
            sx={iconStyle}
          >
            <PreviewIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </Tooltip>
      )}

      {canDelete && (
        <Tooltip title="Delete" arrow>
          <IconButton
            onClick={onDelete}
            disabled={selectedRows.length === 0}
            sx={iconStyle}
          >
            <DeleteForeverIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </Tooltip>
      )}

      {canApprove && (
        <Tooltip title="Approve" arrow>
          <IconButton
            onClick={onApprove}
            disabled={selectedRows.length === 0}
            sx={iconStyle}
          >
            <CheckCircleIcon fontSize={isMobile ? "small" : "medium"} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default RibbonNavbar;
